import React from 'react';

const Tooltip = ({ children, text }) => {
  return (
    <div className="relative group flex items-center">
      {children}
      <div className="absolute bottom-full mb-2 w-max max-w-xs bg-slate-800 text-white text-sm rounded-lg py-2 px-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-10 shadow-lg">
        {text}
      </div>
    </div>
  );
};

export default Tooltip;
